import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';

export class ConsumptionDay extends ModelBase {
  constructor(data?: any) {
    super();
    if (data) {
      this.consumptionDate = LocalDate.fromDate(data.consumptionDate);
      this.cost = data.cost ? new Money(data.cost.currencyCode, data.cost.amount) : null;
      this.pricePerUnit = data.pricePerUnit ? new Money(data.pricePerUnit.currencyCode, data.pricePerUnit.amount) : null;
      this.hasBeenInvoiced = data.hasBeenInvoiced;
      this.consumption = data.consumption;
    }
  }
  consumptionDate: LocalDate;
  hasBeenInvoiced: boolean;
  cost: Money;
  pricePerUnit: Money;
  consumption: number;
}
